import { Alert, Box, Divider, useTheme } from "@mui/material";
import React from "react";

import { useAuth } from "@/providers";
import { NavigationPage, PageHeader } from "@/shared/components";

import { DevicesTable } from "./DevicesTable";

const dividerStyles = {
  marginTop: 2,
  marginBottom: 2,
};

export const Devices: React.FC = () => {
  const { currentOrganization } = useAuth();
  const theme = useTheme();

  return (
    <NavigationPage title={"Roboto - Devices"}>
      <PageHeader>Devices</PageHeader>

      <Divider sx={dividerStyles} />

      <Box marginTop={theme.spacing(3)} marginBottom={theme.spacing(3)}>
        <Box marginBottom={theme.spacing(3)}>
          <Alert severity="info">
            Devices are robots, systems, or other non-human entities that can
            interact with Roboto on behalf of your organization.
          </Alert>
        </Box>
        <DevicesTable orgId={currentOrganization?.org_id} />
      </Box>
    </NavigationPage>
  );
};
